var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSector = function SvgSector(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "sector_svg__svg-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sector_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.371 17.515a5.812 5.812 0 0 0 3.252 0l1.79 2.748a8.97 8.97 0 0 1-3.413.672 8.97 8.97 0 0 1-3.417-.674l1.788-2.746ZM20.943 10.944a8.985 8.985 0 0 1-3.668 8.28l-1.739-2.678a5.8 5.8 0 0 0 2.273-4.462l3.134-1.14ZM6.191 12.086a5.8 5.8 0 0 0 2.269 4.458l-1.74 2.679a8.986 8.986 0 0 1-3.665-8.278l3.136 1.14ZM10.933 6.222a5.822 5.822 0 0 0-4.397 3.723L3.54 8.86A9.007 9.007 0 0 1 10.935 3l-.002 3.222ZM13.06 3a9.006 9.006 0 0 1 7.4 5.858l-2.998 1.085a5.82 5.82 0 0 0-4.4-3.722L13.06 3Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sector_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgSector as ReactComponent };